'use client';

import Icon from '@/components/ui/AppIcon';
import type { Listing } from './DashboardInteractive';

interface ExportButtonProps {
  listings: Listing[];
}

export default function ExportButton({ listings }: ExportButtonProps) {
  const handleExport = () => {
    const headers = ['ID', 'Title', 'Status', 'Category', 'Price', 'Condition', 'Location', 'Owner Email', 'Updated At'];
    const rows = listings.map(l => [
      l.id, `"${l.title}"`, l.status, l.category, l.price, l.condition, `"${l.location}"`, l.owner_email, l.updated_at
    ]);
    const csv = [headers.join(','), ...rows.map(r => r.join(','))].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `listings-export-${Date.now()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <button
      onClick={handleExport}
      className="flex items-center gap-1.5 px-3 py-2 border border-[var(--color-border)] bg-[var(--color-card)] text-[var(--color-foreground)] rounded text-sm font-medium hover:bg-[var(--color-muted)] transition-colors"
    >
      <Icon name="ArrowDownTrayIcon" size={15} variant="outline" />
      Export CSV
    </button>
  );
}